import Address from "../../app/data/account/Address";
import { AddressModel } from "../../app/data/common/address";

export const formatAddress = (address: AddressModel) => (`${address.address1}, ${address.city}, ${address.state} ${address.postalCode || ""}`);

export const transformAddress = (address: AddressModel, country: string = "USA"): Address => ({
    line1: address.address1,
    line2: "",
    city: address.city,
    state: address.state,
    zip: address.postalCode,
    country: country,
    ...(address.additionalAddressLine && { additionalAddressLine: address.additionalAddressLine })
  })